import {useState, useRef, useEffect} from 'react'
import useAuth from '../../hooks/useAuth';
import useAxios from '../../api/axios';
import bg from '../../assets/background.jpg';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import { useNavigate, useLocation} from 'react-router-dom';
import { toast } from 'react-toastify';

const LOGIN_URL = "login?action=login";

const Login = () => {
    const {setAuth} = useAuth();

    const api = useAxios();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/myyntipaikat-kartta";

    const errRef = useRef();

    const [username, setUsername] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');    



    useEffect(() => {

        setErrMsg('');
    },[username,pwd]);


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {

            
            const response = await api.post(LOGIN_URL,
                JSON.stringify({action: "login", email: username, password: pwd}),
                {
                    headers: { 'Content-Type': 'application/json'},
                    withCredentials : true
                }
            );
            const accessToken = response?.data?.token;
            const user = response?.data?.user;
            setAuth( {user, accessToken});
            setUsername('');
            setPwd('');
            toast.info(`Tervetuloa ${user.name}.`);
            navigate(from, {replace: true});
        } catch(err) {
            if(!err?.response) {
                toast.error("Ei vastausta palvelimelta");
                //setErrMsg("Ei vastausta palvelimelta");
            } else if(err.response?.status === 400) {
                toast.error("Palvelin virhe");
                //setErrMsg("Palvelin virhe");
            } else if(err.response?.status === 401) {
                toast.error("Tunnukset eivät kelpaa");
                //setErrMsg("Tunnukset eivät kelpaa");
            } else {
                toast.error("Kirjautuminen epäonnistui");
                //setErrMsg("Kirjautuminen epäonnistui");
            }
            errRef.current.focus();
        }        
    }

  return (
    <div
      className="relative min-h-[calc(100vh-56px)] overflow-hidden bg-slate-900 bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="absolute inset-0 bg-slate-950/60" />

      <div className="relative mx-auto flex min-h-[calc(100vh-56px)] max-w-5xl items-center justify-center px-4 py-10">
        <div className="w-full max-w-xl rounded-3xl border border-white/20 bg-white/10 p-6 text-center shadow-2xl backdrop-blur-md sm:p-8">
          <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
          <h1 className="mb-2 text-4xl font-bold text-white">Kirjaudu</h1>
          <p className="mb-6 text-sm text-slate-100">Kirjaudu sisään varataksesi ja hallitaksesi myyntipaikkoja ja muuttaaksesi omia tietojasi.</p>

          <form onSubmit={handleSubmit}>
            <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
              <TextField
                variant="filled"
                margin="normal"
                label="Käyttäjätunnus"
                value={username}
                sx={{
                  width: { xs: '100%', sm: '70%' },
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  borderRadius: '8px',
                }}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                variant="filled"
                margin="normal"
                label="Salasana"
                type="password"
                value={pwd}
                sx={{
                  width: { xs: '100%', sm: '70%' },
                  backgroundColor: 'rgba(255,255,255,0.95)',
                  borderRadius: '8px',
                }}
                onChange={(e) => setPwd(e.target.value)}
              />
            </Stack>

            <div className="mt-2 text-center text-sm text-white">
              <Link to="/uusi-salasana" className="underline underline-offset-2 hover:text-blue-200">Unohtuiko salasana?</Link>
            </div>

            <div className="mt-3 text-center text-sm text-slate-100">
              Eikö sinulla ole vielä tunnuksia?{' '}
              <Link to="/register" className="font-semibold underline underline-offset-2 hover:text-blue-200">
                Rekisteröidy tästä
              </Link>
            </div>

            <Stack direction="row" alignItems="center" justifyContent="center" sx={{ p: 2, flexWrap: 'wrap' }} spacing={2}>
              <Button type="submit" variant="contained" color="primary">Kirjaudu</Button>
              <Button variant="contained" color="secondary" href="/">Takaisin</Button>
            </Stack>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login